var map = {
	"./1234.jpg": "6a3e",
	"./1234.png": "52e4",
	"./3.0/1.jpg": "4d82",
	"./3.0/2.jpg": "b793",
	"./3.0/3.jpg": "6b05",
	"./3.0/4.jpg": "6da1",
	"./3.0/5.jpg": "e208",
	"./3.0/6.jpg": "e230",
	"./4.0/30.jpg": "f985",
	"./4.0/31.jpg": "44c0",
	"./4.0/32.jpg": "dd03",
	"./4.0/33.jpg": "6bb3",
	"./4.0/34.jpg": "3ea2",
	"./4.0/35.jpg": "bcfe",
	"./4.0/36.jpg": "a3f5",
	"./4.0/37.jpg": "5273",
	"./4.0/38.jpg": "09ea",
	"./4.0/39.jpg": "05de",
	"./4.0/40.jpg": "37fe",
	"./4.0/41.jpg": "7a6d",
	"./4.0/42.jpg": "6cc8",
	"./4.0/43.jpg": "ff01",
	"./4.0/44.jpg": "c435",
	"./4.0/45.jpg": "dbed",
	"./4.0/46.jpg": "01f6",
	"./4.0/47.jpg": "23bd",
	"./4.0/48.jpg": "5c65",
	"./4.0/49.jpg": "f961",
	"./4.0/50.jpg": "34a3",
	"./4.0/51.jpg": "bf2c",
	"./4.0/52.jpg": "2ff9",
	"./4.0/53.jpg": "ffa5",
	"./4.0/54.jpg": "ea77",
	"./4.0/55.jpg": "f0e2",
	"./4.0/56.jpg": "1a9d",
	"./4.0/57.jpg": "094f",
	"./4.0/58.jpg": "2c52",
	"./4.0/59.jpg": "cb44",
	"./4.0/60.jpg": "9c2a",
	"./4.0/61.jpg": "8dbd",
	"./4.0/62.jpg": "e8a5",
	"./Evogria Italic.otf": "8436",
	"./Evogria Italic.woff": "4fb8",
	"./Evogria.otf": "d6bc",
	"./Evogria.ttf": "2d35",
	"./Evogria.woff": "fc79",
	"./about.png": "8615",
	"./about1.jpg": "2a2e",
	"./carousel/slide1.jpg": "e00e",
	"./carousel/slide2.jpg": "2a11",
	"./carousel/slide3.jpg": "f097",
	"./carousel/slide4.jpg": "5ff7",
	"./contact1.jpg": "cba0",
	"./dashboard-bg.jpg": "e52f",
	"./eventbg.jpg": "7f79",
	"./exhibitor1.jpg": "25ee",
	"./exhibitor1.png": "6995",
	"./gallery-hero.jpg": "3510",
	"./gallery/1.jpg": "30e0",
	"./gallery/10.jpg": "30d0",
	"./gallery/11.jpg": "0d7f",
	"./gallery/12.jpg": "4d91",
	"./gallery/13.jpg": "703e",
	"./gallery/14.jpg": "c8d7",
	"./gallery/15.jpg": "2c51",
	"./gallery/16.jpg": "2dc7",
	"./gallery/17.jpg": "67a1",
	"./gallery/18.jpg": "df45",
	"./gallery/19.jpg": "6cb6",
	"./gallery/2.jpg": "1027",
	"./gallery/20.jpg": "b8b0",
	"./gallery/21.jpg": "d0ad",
	"./gallery/22.jpg": "1c4c",
	"./gallery/23.jpg": "7e2b6",
	"./gallery/24.jpg": "7ea0",
	"./gallery/25.jpg": "0822",
	"./gallery/26.jpg": "ff5b",
	"./gallery/27.jpg": "af8d",
	"./gallery/28.jpg": "2995",
	"./gallery/29.jpg": "3be7",
	"./gallery/3.jpg": "498a0",
	"./gallery/4.jpg": "2507",
	"./gallery/5.jpg": "49f2",
	"./gallery/6.jpg": "ec03",
	"./gallery/7.jpg": "ef7f",
	"./gallery/8.jpg": "8b6e",
	"./gallery/9.jpg": "839a",
	"./institutes/4.0/1.png": "1ce8",
	"./institutes/4.0/10.png": "66bb",
	"./institutes/4.0/11.png": "26a8",
	"./institutes/4.0/12.png": "8437",
	"./institutes/4.0/13.png": "b653",
	"./institutes/4.0/14.png": "0c41",
	"./institutes/4.0/2.png": "ad38",
	"./institutes/4.0/3.png": "c5cb",
	"./institutes/4.0/4.png": "ee7f",
	"./institutes/4.0/5.png": "61a5",
	"./institutes/4.0/6.png": "8e6c",
	"./institutes/4.0/7.png": "715a",
	"./institutes/4.0/8.png": "0fbc",
	"./institutes/4.0/9.png": "f4d8",
	"./institutes/AIMS.png": "6d4a",
	"./institutes/AJEENKYA.png": "ff3c",
	"./institutes/AsiaPacific.jpg": "cb58",
	"./institutes/BIBS.jpg": "7f1e",
	"./institutes/DMTIMS LOGO.jpg": "0f46",
	"./institutes/DOONBUSINESSSCHOOL.png": "9bfb",
	"./institutes/EIILM.jpg": "ba47",
	"./institutes/FIIB.png": "0484",
	"./institutes/GLBAJAJ.jpg": "5682",
	"./institutes/GNIOT LOGO.jpg": "dc4b",
	"./institutes/IEM.png": "35cb",
	"./institutes/IILM.jpg": "e31e",
	"./institutes/IMM.jpeg": "9528",
	"./institutes/ISBR.png": "ab4a",
	"./institutes/ITEMUNIVERSITY.png": "8898",
	"./institutes/ITMGROUPOFINSTITUTIONS.png": "eb48",
	"./institutes/KL.png": "cfa0",
	"./institutes/MODYUNIVERSITY.png": "21d8",
	"./institutes/NSHM.jpg": "b201",
	"./institutes/UNITEDWORLDSCHOOLOFBUSINESS.jpg": "d7f1",
	"./institutes/fostiima.jpg": "9baa",
	"./institutes/gbs-logo.png": "2d67",
	"./institutes/iibs_logo.jpg": "cccd",
	"./institutes/ismr.jpg": "d540",
	"./institutes/izee.jpg": "b3e6",
	"./institutes/jisulogo.png": "7d3f",
	"./institutes/kcm.jpg": "6c5e",
	"./institutes/lexicon.jpg": "79a7",
	"./institutes/lexicon.png": "7b2b",
	"./institutes/parul.jpeg": "9a44",
	"./institutes/piet.png": "199f",
	"./institutes/praxis.png": "e1ec",
	"./institutes/presidency.jpg": "bdbd",
	"./institutes/riim.jpg": "d91a",
	"./institutes/rrinstitution.jpg": "da22",
	"./institutes/sanjivani_group_logo_.png": "8f0f",
	"./institutes/sbs.jpg": "996e",
	"./institutes/sunstone.jpg": "4321",
	"./logo1.png": "534f",
	"./logo111.png": "6b59",
	"./logo2.png": "5fbe",
	"./new-4.png": "949e",
	"./registration.jpg": "ad6e",
	"./registration1.jpg": "0c5d",
	"./review.jpg": "9ad8",
	"./school-logo1 (2).png": "101f",
	"./spotlight.jpeg": "25de",
	"./spotlight.jpg": "df06",
	"./student1.jpg": "3948",
	"./student1.png": "8ba4",
	"./testimonial/ab.jpg": "fce8",
	"./testimonial/kb.jpg": "a720",
	"./testimonial/mb.jpg": "37ef",
	"./testimonial/mi.jpg": "6723",
	"./upcoming3.jpg": "443c",
	"./upcoming3.png": "63b0",
	"./ven.png": "9f15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";